/* AV2 - Fiche produit V3 (FICHES-PRODUITS-V3, lot V3-A)
   Comportements de sections/av2-fiche-produit.liquid et des sections av2-fiche-* :
   galerie, choix des variantes en carres, partage, envoi de la demande de devis,
   synchronisation du guide de choix, barre collante, video chargee au clic.
   Sans JavaScript, la fiche reste utilisable : la galerie defile, le formulaire
   /cart/add envoie la variante par defaut et ouvre la page devis (return_to).
=================================== */
(function () {
  'use strict';

  /* Le fichier est appele par plusieurs sections (principale, video, barre) : un seul
     demarrage, sinon chaque gestionnaire est pose deux fois (double ajout a la demande). */
  if (window.av2FicheDemarre) return;
  window.av2FicheDemarre = true;

  /* « 1 726,00 € » : pendant de snippets/av2-prix-fr.liquid. */
  function av2FormatPrix(centimes) {
    var n = (Number(centimes) || 0) / 100;
    return n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  window.av2FormatPrix = av2FormatPrix;

  /* Ajout au panier partage (GRILLE-CONSOMMABLES) : un seul POST /cart/add.js pour un ou
     plusieurs articles, mini-panier du theme mis a jour (sections rendues dans la meme
     reponse) puis ouvert, evenement cart:item-add. Utilise par le bouton « Ajouter au
     panier » de la fiche consommable et par la grille de commande (assets/av2-grille.js).
     items : [{ id, quantity }] ; declencheur : element qui ouvre le mini-panier ;
     avantOuverture : rappel facultatif, appele apres la mise a jour du panier et avant
     l'ouverture du tiroir. Renvoie une promesse : la reponse de /cart/add.js, ou
     { redirection: true } si le theme renvoie vers la page panier ; rejet si l'ajout echoue. */
  function av2PanierAjouter(items, declencheur, avantOuverture) {
    var mini = window.miniCart || document.querySelector('mini-cart');
    var sections = [];
    try {
      if (mini && mini.getSectionsToRender) sections = mini.getSectionsToRender().map(function (x) { return x.section; });
    } catch (err) { sections = []; }
    sections = sections.filter(function (x, k) { return x && sections.indexOf(x) === k; });
    var corps = { items: items };
    if (sections.length) {
      corps.sections = sections.join(',');
      corps.sections_url = window.location.pathname;
    }
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(corps)
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok || res.data.status) throw new Error(res.data.description || res.data.message || 'ajout');
        if (window.themeSettings && window.themeSettings.redirectToCart) {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return { redirection: true };
        }
        if (mini && res.data.sections && mini.renderContents) {
          try { mini.renderContents(res.data); } catch (err) { if (mini.updateSectionContents) mini.updateSectionContents(); }
        }
        if (avantOuverture) avantOuverture(res.data);
        if (mini && mini.open) {
          try { mini.open(declencheur); } catch (err) { /* tiroir absent : la confirmation suffit */ }
        }
        document.dispatchEvent(new CustomEvent('cart:item-add', { detail: { items: [res.data], context: 'av2-fiche' } }));
        return res.data;
      });
  }
  window.av2PanierAjouter = av2PanierAjouter;

  /* « 27 kg », « 25,5 kg » : pendant de snippets/av2-poids.liquid (grammes). */
  function av2FormatPoids(grammes) {
    var g = Number(grammes) || 0;
    if (g <= 0) return '';
    return (g / 1000).toLocaleString('fr-FR', { maximumFractionDigits: 1 }) + ' kg';
  }

  function lireJSON(racine, selecteur) {
    var el = racine.querySelector(selecteur);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /* FICHES-SELECTEUR (passe 2) : trois faits cles du panneau de choix (cle de
     custom.donnees, libelle), memes mises en forme que snippets/av2-fiche-selecteur-faits.liquid :
     tout changement aux deux endroits. Le reste est dans la fiche technique. */
  var FAITS_SELECTEUR = [['coupe', 'Coupe'], ['feuilles', 'Par passage, 80 g/m²'], ['corbeille', 'Corbeille']];

  function texteFait(cle, libelle, val) {
    if (cle === 'coupe' && val.indexOf('en ') === 0) val = val.slice(3).replace(' de ', ' ');
    if (cle === 'feuilles' && val.toLowerCase().indexOf('feuille') < 0) val += ' feuilles';
    if (cle === 'corbeille' && val.indexOf(',') > -1) {
      libelle += ', ' + val.slice(val.indexOf(',') + 1).trim();
      val = val.slice(0, val.indexOf(',')).trim();
    }
    return [libelle, val];
  }

  function ajouterFait(liste, cle, libelle, valeur) {
    var ligne = document.createElement('div');
    ligne.setAttribute('data-fait', cle);
    var dt = document.createElement('dt');
    dt.textContent = libelle;
    var dd = document.createElement('dd');
    dd.textContent = valeur;
    ligne.appendChild(dt);
    ligne.appendChild(dd);
    liste.appendChild(ligne);
  }

  /* ---------------- Fiche principale ---------------- */
  function initFiche(racine) {
    var variantes = lireJSON(racine, '[data-av2-variantes]') || [];
    var guide = lireJSON(racine, '[data-av2-guide]');
    var champId = racine.querySelector('[data-av2-id]');
    /* Consommable (V3-C) : achat direct, libelles et index de la couleur. */
    var conso = racine.hasAttribute('data-av2-conso');
    var consoDonnees = lireJSON(racine, '[data-av2-conso-donnees]') || { libelles: {}, couleur: -1, nom: '' };
    var courante = variantes.filter(function (v) { return String(v.id) === (champId && champId.value); })[0] || variantes[0];

    /* --- Galerie --- */
    var slides = racine.querySelector('[data-av2-slides]');
    var compteur = racine.querySelector('[data-av2-compteur]');
    var nbSlides = slides ? slides.querySelectorAll('[data-av2-slide]').length : 0;

    function allerA(index) {
      if (!slides) return;
      /* Une photo chargee en differe ne se charge pas toujours quand la galerie defile
         par programme (choix d'une variante) : on la charge avant d'y aller. */
      var cible = slides.querySelectorAll('[data-av2-slide]')[index];
      var img = cible && cible.querySelector('img[loading="lazy"]');
      if (img) img.loading = 'eager';
      slides.scrollTo({ left: index * slides.clientWidth, behavior: 'smooth' });
      marquer(index);
    }

    function marquer(index) {
      if (compteur) compteur.textContent = (index + 1) + ' / ' + nbSlides;
      racine.querySelectorAll('[data-av2-aller]').forEach(function (b) {
        if (Number(b.getAttribute('data-av2-aller')) === index) {
          b.setAttribute('aria-current', 'true');
        } else {
          b.removeAttribute('aria-current');
        }
      });
    }

    if (slides) {
      var attente;
      slides.addEventListener('scroll', function () {
        clearTimeout(attente);
        attente = setTimeout(function () {
          marquer(Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth)));
        }, 60);
      }, { passive: true });
      racine.querySelectorAll('[data-av2-aller]').forEach(function (b) {
        b.addEventListener('click', function () {
          allerA(Number(b.getAttribute('data-av2-aller')));
        });
      });
    }

    function allerAuMedia(mediaId) {
      if (!slides || !mediaId) return;
      var liste = Array.prototype.slice.call(slides.querySelectorAll('[data-av2-slide]'));
      var i = liste.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
      if (i >= 0) allerA(i);
    }

    /* --- Mosaique du mobilier (B2.1) : photos communes + photos de la couleur choisie,
       dans la limite des tuiles (8, ou 7 avec la video) ; « +N » = photos restantes de
       la grande galerie. Meme regle que le rendu Liquid. --- */
    var iCouleur = racine.hasAttribute('data-av2-mobilier') ? Number(racine.getAttribute('data-av2-i-couleur')) : -1;
    function mosaique(v) {
      if (iCouleur < 0 || !v) return;
      var tuiles = racine.querySelectorAll('.av2-fp-vignette[data-av2-couleur]');
      if (!tuiles.length) return;
      var couleur = v.options[iCouleur];
      var max = racine.querySelector('.av2-fp-vignette-video') ? 7 : 8;
      var montrees = [];
      tuiles.forEach(function (t) {
        var c = t.getAttribute('data-av2-couleur');
        var garder = (!c || c === couleur) && montrees.length < max;
        t.hidden = !garder;
        if (garder) montrees.push(t);
        var plus = t.querySelector('[data-av2-plus]');
        if (plus) plus.remove();
      });
      var reste = nbSlides - montrees.length;
      if (reste > 0 && montrees.length) {
        var marque = document.createElement('span');
        marque.className = 'av2-fp-vignette-plus';
        marque.setAttribute('data-av2-plus', '');
        marque.textContent = '+' + reste;
        montrees[montrees.length - 1].appendChild(marque);
      }
      var grille = racine.querySelector('.av2-fp-vignettes');
      if (grille) {
        var nb = montrees.length + (racine.querySelector('.av2-fp-vignette-video') ? 1 : 0);
        grille.style.setProperty('--av2-nb-vign', Math.min(4, Math.max(1, nb)));
      }
    }

    /* --- Mobilier (B4) : « Équiper plusieurs postes ». Le nombre saisi est la quantite
       envoyee au devis ; la barre mobile le reprend (« 3 postes »). --- */
    var champQte = racine.querySelector('[data-av2-qte]');
    function lireQte() {
      if (!champQte) return 1;
      var n = parseInt(champQte.value, 10);
      if (!(n >= 1)) n = 1;
      return Math.min(999, n);
    }
    function poserQte(n) {
      if (!champQte) return;
      n = Math.min(999, Math.max(1, n));
      champQte.value = n;
      document.querySelectorAll('[data-av2-postes-texte]').forEach(function (el) {
        el.textContent = n > 1 ? n + ' postes' : '1 poste';
      });
      /* Mobilier (DESIGN-FICHES, point 7) : la carte de taille de projet suit le compteur. */
      racine.querySelectorAll('[data-av2-taille]').forEach(function (b) {
        var dans = n >= Number(b.getAttribute('data-min')) && n <= Number(b.getAttribute('data-max'));
        b.setAttribute('aria-pressed', dans ? 'true' : 'false');
      });
      /* Consommable : « × 3 » dans la barre mobile. */
      document.querySelectorAll('[data-av2-qte-texte]').forEach(function (el) {
        el.textContent = String(n);
      });
    }
    if (champQte) {
      racine.querySelectorAll('[data-av2-qte-pas]').forEach(function (b) {
        b.addEventListener('click', function () {
          poserQte(lireQte() + Number(b.getAttribute('data-av2-qte-pas')));
        });
      });
      /* Mobilier : une carte de taille de projet regle le compteur sur sa valeur de depart. */
      racine.querySelectorAll('[data-av2-taille]').forEach(function (b) {
        b.addEventListener('click', function () {
          poserQte(Number(b.getAttribute('data-av2-taille')));
        });
      });
      champQte.addEventListener('change', function () { poserQte(lireQte()); });
      champQte.addEventListener('input', function () {
        if (champQte.value !== '') poserQte(lireQte());
      });
    }

    /* --- Galerie collante : decalage sous l'en-tete collant du theme ---
       L'en-tete reapparait en remontant : son bas visible est reporte dans
       --av2-entete (0 quand il est masque). */
    var entete = document.querySelector('sticky-header, .section-header');
    if (entete) {
      var attenteEntete = false;
      var mesurer = function () {
        attenteEntete = false;
        var bas = Math.max(0, Math.round(entete.getBoundingClientRect().bottom));
        racine.style.setProperty('--av2-entete', bas + 'px');
      };
      window.addEventListener('scroll', function () {
        if (attenteEntete) return;
        attenteEntete = true;
        window.requestAnimationFrame(mesurer);
      }, { passive: true });
      mesurer();
    }

    /* --- Variantes --- */
    /* Variante qui reprend les options courantes en changeant l'option i.
       exact : sans repli ; sinon, a defaut, la 1re variante qui porte cette valeur. */
    function trouver(options, i, valeur, exact) {
      var voulues = (options || []).slice();
      voulues[i] = valeur;
      var v = variantes.filter(function (x) {
        return x.options.every(function (o, k) { return o === voulues[k]; });
      })[0];
      if (v || exact) return v;
      return variantes.filter(function (x) { return x.options[i] === valeur; })[0];
    }

    function appliquer(v, depuisGuide, initial) {
      if (!v) return;
      courante = v;
      if (champId) champId.value = v.id;

      /* HT et TTC : plusieurs emplacements (prix principal, rappel, barre mobile).
         Sur devis : aucun prix dans les donnees (null), rien a ecrire. */
      if (v.ht != null) {
        document.querySelectorAll('[data-av2-ht]').forEach(function (el) { el.textContent = av2FormatPrix(v.ht); });
        document.querySelectorAll('[data-av2-ttc]').forEach(function (el) { el.textContent = av2FormatPrix(v.prix); });
      }

      /* Sur devis : resume de la demande et lien du bouton (produit + variante). */
      document.querySelectorAll('[data-av2-resume]').forEach(function (el) {
        var nom = el.getAttribute('data-nom') || '';
        var defaut = v.options.length === 1 && v.options[0] === 'Default Title';
        el.textContent = defaut ? nom : [nom].concat(v.options).join(' · ');
      });
      /* Mobilier (points 7 et 9) : configuration dans le pied « Votre demande » (valeurs telles quelles). */
      racine.querySelectorAll('[data-av2-bureaux-config]').forEach(function (el) {
        el.textContent = v.options.join(' · ');
      });
      document.querySelectorAll('[data-av2-devis-lien]').forEach(function (a) {
        a.href = a.getAttribute('data-base') + '&variante=' + v.id;
      });

      var ligneRef = racine.querySelector('[data-av2-ref]');
      if (ligneRef) {
        racine.querySelector('[data-av2-ref-valeur]').textContent = v.ref || '';
        ligneRef.hidden = !v.ref;
      }

      var poids = av2FormatPoids(v.poids);
      var lignePoids = racine.querySelector('[data-av2-poids-ligne]');
      if (lignePoids) {
        racine.querySelector('[data-av2-poids]').textContent = poids;
        lignePoids.hidden = !poids;
      }
      var ligneEco = racine.querySelector('[data-av2-eco-ligne]');
      if (ligneEco) {
        racine.querySelector('[data-av2-eco]').textContent = v.eco != null ? av2FormatPrix(v.eco) : '';
        ligneEco.hidden = v.eco == null;
      }

      racine.querySelectorAll('[data-av2-option]').forEach(function (groupe) {
        var i = Number(groupe.getAttribute('data-av2-option'));
        groupe.querySelectorAll('[data-av2-valeur]').forEach(function (b) {
          var valeurBouton = b.getAttribute('data-av2-valeur');
          b.setAttribute('aria-pressed', valeurBouton === v.options[i] ? 'true' : 'false');
          /* Combinaison absente du catalogue (ex. lubrification automatique en P-2) : grisee.
             Seulement pour une option secondaire (commande segmentee) : un carre de la
             1re option reste cliquable et bascule sur la version qui existe (P-2 manuelle). */
          var existe = !groupe.classList.contains('av2-fp-choix-segment') || trouver(v.options, i, valeurBouton, true);
          b.disabled = !existe;
          /* Mobilier (data-av2-exact) : combinaison absente grisee mais cliquable, le clic
             bascule sur la variante qui existe ; aucun choix bloque. */
          if (groupe.hasAttribute('data-av2-exact')) {
            existe = !!trouver(v.options, i, valeurBouton, true);
            b.disabled = false;
          }
          if (existe) {
            b.removeAttribute('data-indisponible');
          } else {
            b.setAttribute('data-indisponible', '');
          }
        });
        /* Listes deroulantes (plus de 6 valeurs, sous-jeux) : la valeur courante si elle
           y figure, sinon l'invite (« Sous-jeux… »). */
        groupe.querySelectorAll('[data-av2-select]').forEach(function (s) {
          var presente = Array.prototype.some.call(s.options, function (o) { return o.value === v.options[i]; });
          s.value = presente ? v.options[i] : '';
          if (presente) {
            s.setAttribute('data-actif', '');
          } else {
            s.removeAttribute('data-actif');
          }
        });
        /* Consommable : une valeur sans combinaison avec les options precedentes est
           masquee (rouge et bleu au-dela de 25 mm), comme le rendu Liquid. */
        if (groupe.hasAttribute('data-av2-masquer') && i > 0) {
          var existeAvec = function (val) {
            return variantes.some(function (x) {
              return x.options[i] === val && x.options.slice(0, i).every(function (o, k) { return o === v.options[k]; });
            });
          };
          groupe.querySelectorAll('[data-av2-valeur]').forEach(function (b) {
            b.hidden = !existeAvec(b.getAttribute('data-av2-valeur'));
          });
          groupe.querySelectorAll('option').forEach(function (o) {
            var absente = !existeAvec(o.value);
            o.hidden = absente;
            o.disabled = absente;
          });
        }
        /* Mobilier : « Couleur : noir » suit la pastille choisie (consommable : libelle court). */
        var libelleCouleur = groupe.querySelector('[data-av2-couleur-libelle]');
        if (libelleCouleur) libelleCouleur.textContent = ((consoDonnees.libelles || {})[v.options[i]] || v.options[i] || '').toLocaleLowerCase('fr-FR');
        var note = groupe.querySelector('[data-av2-note]');
        if (note && guide) {
          var texte = (guide.notes && guide.notes[v.options[i]]) || '';
          var horsCatalogue = groupe.querySelector('[data-indisponible]');
          if (horsCatalogue && guide.indisponible) {
            texte = guide.indisponible.replace('{code}', (v.options[0] || '').split('/')[0].trim());
          }
          note.textContent = texte;
          note.hidden = !texte;
        }
      });

      var info = racine.querySelector('[data-av2-info]');
      if (info && guide) {
        var valeur = v.options[0] || '';
        var code = valeur.split('/')[0].trim();
        var detail = valeur.indexOf('/') > -1 ? valeur.slice(valeur.indexOf('/') + 1).trim() : '';
        info.querySelector('[data-av2-info-code]').textContent = code;
        info.querySelector('[data-av2-info-usage]').textContent = guide.usages[code] || '';
        /* FICHES-SELECTEUR (passe 2) : trois faits cles, indicateur du niveau DIN. */
        var d = v.donnees || {};
        var liste = info.querySelector('[data-av2-info-faits]');
        liste.innerHTML = '';
        var nbFaits = 0;
        FAITS_SELECTEUR.forEach(function (f) {
          var val = String(d[f[0]] || '').trim();
          if (!val) return;
          var t = texteFait(f[0], f[1], val);
          ajouterFait(liste, f[0], t[0], t[1]);
          nbFaits += 1;
        });
        if (!nbFaits && !v.donnees && detail) {
          ajouterFait(liste, 'detail', info.getAttribute('data-detail') || guide.detail || 'Détail', detail);
          nbFaits = 1;
        }
        liste.hidden = !nbFaits;
        var niveau = /^P-(\d)/.test(code) ? Number(code.slice(2, 3)) : 0;
        info.querySelectorAll('[data-av2-echelle] [data-niveau]').forEach(function (i) {
          i.classList.toggle('is-plein', Number(i.getAttribute('data-niveau')) <= niveau);
        });
        var legende = info.querySelector('[data-av2-echelle-legende] b');
        if (legende) legende.textContent = code;
        var blocEchelle = info.querySelector('[data-av2-echelle-bloc]');
        if (blocEchelle) blocEchelle.hidden = !niveau;
        /* Petit rebond a chaque changement de niveau (coupe si mouvement refuse). */
        info.classList.remove('av2-change');
        void info.offsetWidth;
        info.classList.add('av2-change');
      }

      /* Donnees de la variante ailleurs sur la fiche (fiche technique : coupe,
         niveaux DIN, poids...) et code de version (« Données HSM, version P-4 »). */
      document.querySelectorAll('[data-av2-donnee]').forEach(function (el) {
        var cle = el.getAttribute('data-av2-donnee');
        var val = cle === 'poids' ? poids : (v.donnees && v.donnees[cle]) || '';
        el.textContent = val;
        var ligne = el.closest('[data-av2-donnee-ligne]');
        if (ligne) ligne.hidden = !val;
      });
      if (v.pdf) {
        document.querySelectorAll('[data-av2-pdf-fiche]').forEach(function (a) { a.href = v.pdf; });
      }
      mosaique(v);
      if (conso) appliquerConso(v);
      document.querySelectorAll('[data-av2-version]').forEach(function (el) {
        el.textContent = (v.options[0] || '').split('/')[0].trim();
      });

      if (initial) return;

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {
        /* URL non modifiable : la selection reste valable dans la page */
      }

      if (!depuisGuide) allerAuMedia(v.media);
      document.dispatchEvent(new CustomEvent('av2:variante', { detail: { id: v.id, ht: v.ht, prix: v.prix, options: v.options } }));
    }

    racine.querySelectorAll('[data-av2-option]').forEach(function (groupe) {
      var i = Number(groupe.getAttribute('data-av2-option'));
      groupe.querySelectorAll('[data-av2-valeur]').forEach(function (b) {
        b.addEventListener('click', function () {
          appliquer(trouver(courante ? courante.options : [], i, b.getAttribute('data-av2-valeur'), false), false);
        });
      });
      groupe.querySelectorAll('[data-av2-select]').forEach(function (s) {
        s.addEventListener('change', function () {
          if (!s.value) return;
          appliquer(trouver(courante ? courante.options : [], i, s.value, false), false);
        });
      });
    });

    /* Guide de choix : une ligne par valeur de la 1re option ; les autres options
       (ex. lubrification) sont conservees quand la combinaison existe. */
    document.addEventListener('av2:choisir', function (e) {
      if (!e.detail) return;
      if (e.detail.valeur != null) {
        /* option : index de l'option visee (guide des tailles des consommables), 0 par defaut. */
        appliquer(trouver(courante ? courante.options : [], Number(e.detail.option) || 0, e.detail.valeur, false), true);
        return;
      }
      var id = String(e.detail.id);
      appliquer(variantes.filter(function (x) { return String(x.id) === id; })[0], true);
    });

    /* --- Consommable (V3-C) : unite, disponibilite, feuilles, bouton, barre --- */
    function appliquerConso(v) {
      var d = v.donnees || {};
      var unite = d.unite || (d.conditionnement ? 'par ' + d.conditionnement : '');
      racine.querySelectorAll('[data-av2-unite]').forEach(function (el) {
        el.textContent = unite;
        el.hidden = !unite;
      });
      racine.querySelectorAll('[data-av2-dispo]').forEach(function (el) {
        el.textContent = v.dispo || '';
        el.hidden = !v.dispo;
      });
      racine.querySelectorAll('[data-av2-feuilles-ligne]').forEach(function (el) {
        var t = d.feuilles ? (d.capacite || d.feuilles + ' feuilles') + (d.conditionnement ? ' · ' + d.conditionnement : '') : '';
        el.querySelector('[data-av2-feuilles-texte]').textContent = t;
        el.hidden = !t;
      });
      var bouton = racine.querySelector('[data-av2-bouton]');
      if (bouton) {
        bouton.disabled = !v.disponible;
        var texte = bouton.querySelector('[data-av2-bouton-texte]');
        if (texte && !bouton.hasAttribute('data-ajoute')) texte.textContent = v.disponible ? bouton.getAttribute('data-texte') : 'Indisponible';
      }
      /* Barre mobile : « 6 mm · noir » (options a plusieurs valeurs, sans parenthese). */
      var multiples = (variantes[0] ? variantes[0].options : []).map(function (o, k) {
        return variantes.some(function (x) { return x.options[k] !== o; });
      });
      var choix = [];
      v.options.forEach(function (o, k) {
        if (!multiples[k]) return;
        var lib = ((consoDonnees.libelles || {})[o] || o).split(' (')[0];
        choix.push(k === consoDonnees.couleur ? lib.toLocaleLowerCase('fr-FR') : lib);
      });
      document.querySelectorAll('[data-av2-choix]').forEach(function (el) {
        el.textContent = choix.join(' · ') || consoDonnees.nom || '';
      });
    }

    /* Etat initial : grise les combinaisons absentes et pose les notes. */
    if (courante) {
      appliquer(courante, true, true);
      /* Lien direct vers une variante (?variant=) : la galerie s'ouvre sur sa photo. */
      if (courante.media) allerAuMedia(courante.media);
    }

    /* --- Partager --- */
    var partager = racine.querySelector('[data-av2-partager]');
    var partageOk = racine.querySelector('[data-av2-partage-ok]');
    if (partager) {
      partager.addEventListener('click', function () {
        var url = window.location.href.split('#')[0];
        if (navigator.share) {
          navigator.share({ title: partager.getAttribute('data-titre'), url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            if (!partageOk) return;
            partageOk.hidden = false;
            setTimeout(function () { partageOk.hidden = true; }, 2500);
          });
        }
      });
    }

    /* --- Envoi de la demande --- */
    var form = racine.querySelector('[data-av2-form]');
    /* Consommable : vrai ajout au panier (/cart/add.js), mini-panier du theme mis a jour
       et ouvert, confirmation sous le bouton. Sans JavaScript : formulaire natif. */
    if (form && window.fetch && form.hasAttribute('data-av2-panier')) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var bouton = form.querySelector('[data-av2-bouton]');
        var erreur = form.querySelector('[data-av2-erreur]');
        var retour = form.querySelector('[data-av2-retour]');
        if (!bouton || bouton.disabled || bouton.getAttribute('aria-busy') === 'true') return;
        var qte = lireQte();
        bouton.setAttribute('aria-busy', 'true');
        if (erreur) erreur.hidden = true;
        if (retour) retour.hidden = true;

        av2PanierAjouter([{ id: Number(champId.value), quantity: qte }], bouton, function () {
          /* Retour visuel (avant l'ouverture du mini-panier) : bouton « Ajouté au panier »,
             ligne de confirmation. */
          bouton.removeAttribute('aria-busy');
          var texte = bouton.querySelector('[data-av2-bouton-texte]');
          bouton.setAttribute('data-ajoute', '');
          if (texte) texte.textContent = 'Ajouté au panier';
          setTimeout(function () {
            bouton.removeAttribute('data-ajoute');
            if (texte) texte.textContent = bouton.disabled ? 'Indisponible' : bouton.getAttribute('data-texte');
          }, 2500);
          if (retour) {
            var choixEl = document.querySelector('[data-av2-choix]');
            var choix = choixEl ? choixEl.textContent : '';
            var nom = consoDonnees.nom || '';
            retour.querySelector('[data-av2-retour-texte]').textContent = qte + ' × ' + nom + (choix && choix !== nom ? ' (' + choix + ')' : '') + (qte > 1 ? ' ajoutés' : ' ajouté') + ' au panier.';
            retour.hidden = false;
          }
        })
          .then(function (res) {
            if (res && res.redirection) bouton.removeAttribute('aria-busy');
          })
          .catch(function (err) {
            bouton.removeAttribute('aria-busy');
            if (erreur) {
              erreur.textContent = "L'ajout au panier n'a pas abouti" + (err && err.message && err.message !== 'ajout' ? ' : ' + err.message : '.') + ' Réessayez, ou appelez-nous au 06 07 21 60 62.';
              erreur.hidden = false;
            }
          });
      });
    } else if (form && window.fetch) {
      /* NET-1 : verrou d'envoi. Un double clic, ou la barre mobile puis le bouton, ne doit
         envoyer qu'une fois /cart/add.js (sinon quantite et options doublees dans le devis).
         Verrou pose des le premier envoi (formulaire + bouton desactive, aria-busy, texte
         « Envoi en cours… »), leve seulement en cas d'echec ; leve aussi au retour arriere
         (page restauree depuis le cache du navigateur). */
      var envoiEnCours = false;
      var boutonDevis = form.querySelector('[data-av2-bouton]');
      var texteDevis = boutonDevis ? boutonDevis.querySelector('span') : null;
      var texteInitial = texteDevis ? texteDevis.textContent : '';
      var verrouiller = function (actif) {
        envoiEnCours = actif;
        if (!boutonDevis) return;
        boutonDevis.disabled = actif;
        if (actif) boutonDevis.setAttribute('aria-busy', 'true'); else boutonDevis.removeAttribute('aria-busy');
        if (texteDevis) texteDevis.textContent = actif ? 'Envoi en cours…' : texteInitial;
      };
      window.addEventListener('pageshow', function (ev) { if (ev.persisted) verrouiller(false); });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (envoiEnCours) return;
        var erreur = form.querySelector('[data-av2-erreur]');
        var proprietes = {};
        form.querySelectorAll('input[type="checkbox"][name^="properties["]').forEach(function (c) {
          if (c.checked) proprietes[c.name.slice(11, -1)] = c.value;
        });
        var items = [{ id: Number(champId.value), quantity: lireQte(), properties: proprietes }];
        form.querySelectorAll('input[data-av2-ajout]').forEach(function (c) {
          if (c.checked) items.push({ id: Number(c.getAttribute('data-av2-ajout')), quantity: 1 });
        });
        var retour = form.querySelector('input[name="return_to"]').value;
        verrouiller(true);
        if (erreur) erreur.hidden = true;

        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('ajout');
            window.location.href = retour;
          })
          .catch(function () {
            verrouiller(false);
            if (erreur) {
              erreur.textContent = "L'ajout à votre demande n'a pas abouti. Réessayez, ou appelez-nous au 06 07 21 60 62.";
              erreur.hidden = false;
            }
          });
      });
    }
  }

  /* ---------------- Guide de choix ---------------- */
  function initGuide(racine) {
    var lignes = racine.querySelectorAll('[data-av2-guide-valeur]');
    lignes.forEach(function (l) {
      l.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('av2:choisir', { detail: { valeur: l.getAttribute('data-av2-guide-valeur') } }));
      });
    });
    document.addEventListener('av2:variante', function (e) {
      var premiere = (e.detail.options || [])[0];
      lignes.forEach(function (l) {
        l.setAttribute('aria-pressed', l.getAttribute('data-av2-guide-valeur') === premiere ? 'true' : 'false');
      });
    });

    /* « Lire le guide complet » : panneau lateral (dialog), sans quitter la fiche. */
    var panneau = racine.querySelector('[data-av2-panneau]');
    var ouvrir = racine.querySelector('[data-av2-panneau-ouvrir]');
    if (panneau && ouvrir && typeof panneau.showModal === 'function') {
      ouvrir.addEventListener('click', function (e) {
        e.preventDefault();
        panneau.showModal();
      });
      panneau.querySelectorAll('[data-av2-panneau-fermer]').forEach(function (b) {
        b.addEventListener('click', function () { panneau.close(); });
      });
      /* Clic sur le voile (hors du contenu) : fermeture. */
      panneau.addEventListener('click', function (e) {
        if (e.target === panneau) panneau.close();
      });
    }
  }

  /* ---------------- Guide des tailles (consommables, V3-C) ----------------
     Une ligne choisit la valeur de l'option (meme couleur si la combinaison existe) ;
     la ligne de la variante courante est marquee. */
  function initTailles(racine) {
    var i = Number(racine.getAttribute('data-av2-option-i')) || 0;
    var lignes = racine.querySelectorAll('[data-av2-tl-valeur]');
    lignes.forEach(function (l) {
      var choisir = function () {
        document.dispatchEvent(new CustomEvent('av2:choisir', { detail: { valeur: l.getAttribute('data-av2-tl-valeur'), option: i } }));
      };
      l.addEventListener('click', choisir);
      l.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          choisir();
        }
      });
    });
    document.addEventListener('av2:variante', function (e) {
      var options = e.detail.options || [];
      lignes.forEach(function (l) {
        l.setAttribute('aria-selected', options.indexOf(l.getAttribute('data-av2-tl-valeur')) > -1 ? 'true' : 'false');
      });
    });
  }

  /* Mode machine : colonnes equilibrees (VIDEO-ENTRETIEN, passe 3). Deplace le 18/10/2026
     (INTEGRATION-2026-10-18) dans un script en ligne a la fin de sections/av2-fiche-produit.liquid :
     la decision se prend avant le premier rendu, la bande de chiffres ne saute plus apres
     le chargement. */

  /* ---------------- Video au clic ---------------- */
  function initVideo(cadre) {
    var bouton = cadre.querySelector('button');
    if (!bouton) return;
    bouton.addEventListener('click', function () {
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(cadre.getAttribute('data-av2-video')) + '?autoplay=1&rel=0';
      iframe.title = bouton.getAttribute('aria-label');
      iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      cadre.replaceChildren(iframe);
    }, { once: true });
  }

  /* ---------------- Barre collante (mobile seulement) ----------------
     En bas d'ecran seulement tout en bas de la page, quand le pied de page arrive a
     l'ecran ; elle repart des qu'on remonte (Nikolas, 02/11/2026 : plus tot, elle
     casse la lecture). Aucune barre sur ordinateur (decision du 14/10/2026 : doublon
     avec la navbar). */
  function initBarre(barre) {
    var bouton = document.querySelector('[data-av2-fp] [data-av2-bouton]');
    var form = document.querySelector('[data-av2-fp] [data-av2-form]');
    if (!bouton || !('IntersectionObserver' in window)) return;
    var mobile = window.matchMedia('(max-width: 989px)');

    function afficher(visible) {
      visible = visible && mobile.matches;
      barre.classList.toggle('is-visible', visible);
      barre.setAttribute('aria-hidden', visible ? 'false' : 'true');
      barre.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = visible ? 0 : -1; });
    }

    // Deux conditions : le bouton principal est depasse (au-dessus de l'ecran) et le pied
    // de page est a l'ecran. Le pied ne bouge pas quand la barre pousse le bas de page
    // (padding du body) : aucun clignotement. Sans pied de page, la barre ne s'affiche pas.
    var horsEcran = false;
    var enBas = false;
    var pied = document.querySelector('footer.footer');
    function maj() { afficher(horsEcran && enBas); }
    new IntersectionObserver(function (entrees) {
      var e = entrees[0];
      horsEcran = !e.isIntersecting && e.boundingClientRect.bottom < 0;
      maj();
    }).observe(bouton);
    if (pied) {
      new IntersectionObserver(function (entrees) {
        enBas = entrees[0].isIntersecting;
        maj();
      }).observe(pied);
    }
    if (mobile.addEventListener) mobile.addEventListener('change', maj);

    var action = barre.querySelector('[data-av2-barre-bouton]');
    if (action && form) {
      action.addEventListener('click', function () {
        if (form.requestSubmit) {
          form.requestSubmit();
        } else {
          bouton.click();
        }
      });
    } else if (action && bouton.href) {
      /* Sur devis : pas de formulaire, le bouton principal est un lien vers le devis. */
      action.addEventListener('click', function () { window.location.href = bouton.href; });
    }

    /* Le prix de la barre (data-av2-ht / data-av2-ttc) suit la variante via appliquer(). */
  }

  function demarrer() {
    /* FICHES-SELECTEUR : « Fiche technique complète » masque si la fiche n'a pas cette section. */
    document.querySelectorAll('[data-av2-sel-plus]').forEach(function (a) {
      if (!document.getElementById((a.getAttribute('href') || '').slice(1))) a.hidden = true;
    });
    document.querySelectorAll('[data-av2-fp]').forEach(initFiche);
    document.querySelectorAll('[data-av2-guide-section]').forEach(initGuide);
    document.querySelectorAll('[data-av2-tailles]').forEach(initTailles);
    /* « Compatible avec » : au-dela de 8 machines, le reste s'ouvre au clic. */
    document.querySelectorAll('[data-av2-cp-tout]').forEach(function (b) {
      b.addEventListener('click', function () {
        var section = b.closest('.av2-cp');
        if (section) section.querySelectorAll('[data-av2-cp-plus]').forEach(function (li) { li.hidden = false; });
        b.remove();
      });
    });
    document.querySelectorAll('[data-av2-video]').forEach(initVideo);
    document.querySelectorAll('[data-av2-barre]').forEach(initBarre);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
